/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {CalculationResultWidget} from './CalculationResultWidget';
import {
  CalculationResultWidgetFromJSON,
  CalculationResultWidgetFromJSONTyped,
  CalculationResultWidgetToJSON
} from './CalculationResultWidget';

/**
 *
 * @export
 * @interface SampleCalculationResult
 */
export interface SampleCalculationResult {
  /**
   *
   * @type {string}
   * @memberof SampleCalculationResult
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof SampleCalculationResult
   */
  sampleUuid: string;
  /**
   *
   * @type {string}
   * @memberof SampleCalculationResult
   */
  name: string;
  /**
   *
   * @type {CalculationResultWidget}
   * @memberof SampleCalculationResult
   */
  widget: CalculationResultWidget;
}

/**
 * Check if a given object implements the SampleCalculationResult interface.
 */
export function instanceOfSampleCalculationResult(value: object): value is SampleCalculationResult {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('sampleUuid' in value) || value['sampleUuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('widget' in value) || value['widget'] === undefined) return false;
  return true;
}

export function SampleCalculationResultFromJSON(json: any): SampleCalculationResult {
  return SampleCalculationResultFromJSONTyped(json, false);
}

export function SampleCalculationResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SampleCalculationResult {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    sampleUuid: json['sample_uuid'],
    name: json['name'],
    widget: CalculationResultWidgetFromJSON(json['widget'])
  };
}

export function SampleCalculationResultToJSON(value?: SampleCalculationResult | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    sample_uuid: value['sampleUuid'],
    name: value['name'],
    widget: CalculationResultWidgetToJSON(value['widget'])
  };
}
